import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 4),
    marginBottom: theme.spacing(2),
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.red_100,
    color: theme.colors.white,
    fontWeight: 600
  },
  link: {
    color: 'inherit',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    fontWeight: 700
  }
});

export default makeStyles(styles);
